import { z } from "zod";
import { baseEntitySchema } from "./base";

export const customerDataSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().email(),
  phone: z.string().min(1),
});

export type CustomerData = z.infer<typeof customerDataSchema>;
export const customerSchema = baseEntitySchema.merge(customerDataSchema);
export type Customer = z.infer<typeof customerSchema>;
